import {DataObject} from "@/services/data/dataObject";
import store from "@/store/store";
import EXCEL_DOWNLOAD from '@/utilities/services/downloads/excel/excelDownload';
import TimeStamp from "@/services/timeStamp";

export class VereinsReporting extends DataObject {
    constructor() {
        super();
        this.vereine = [];
        this.landesVerbaende = []
        this.selectedVerbandId = ''
        this.setLandesVerbaende()
        this.lvList = []
        this.filteredList = []
    }

    setLandesVerbaende(){
        const landesVerbaende = store.state.local.landesverbaende.map(lv=>({...lv, text: lv.id + ' - ' + lv.name}))
        landesVerbaende.unshift({text: 'Vereine Classic', id: '10', name: 'Vereine', nameShort: 'alle ', sportart: '', wappen: ''})
        landesVerbaende.unshift({text: 'Vereine Bowling', id: '20', name: 'Vereine', nameShort: 'alle ', sportart: '', wappen: ''})
        landesVerbaende.unshift({text: 'alle Vereine (Classic und Bowling)', id: '00', name: 'Vereine', nameShort: 'alle ', sportart: '', wappen: ''})
        this.landesVerbaende = landesVerbaende
    }
    setFilteredItems(filteredList){
        this.filteredList = filteredList
    }

    loadVereineFromVerbandId() {
        if ( this.selectedVerbandId === '' ) return
        this.setLVList()
        this.verifyLVs()
    }
        setLVList(){
            this.lvList = this.selectedVerbandId === '00' ? store.state.local.landesverbaende :
                    this.selectedVerbandId === '10' ? store.state.local.landesverbaende.filter(lv => lv.id < '20') :
                    this.selectedVerbandId === '20' ? store.state.local.landesverbaende.filter(lv => lv.id > '20') :
                    [{id: this.selectedVerbandId}]
        }

        verifyLVs(){
            this.lvList.forEach( (lv) => {
                if ( !store.state.realtime.landesverbaende[lv.id] ) {
                    this.bindLV(lv.id)
                }
            });
        }

        bindLV(id){
            store.dispatch('bindRealtimeDocument', {
                collection: 'landesverbaende',
                docId: id,
                storeField: 'landesverbaende.' + id,
            });
        }

    getVereinsList(){
        let vereinsListe = []
        this.lvList.forEach( (lv) => {
            if ( store.state.realtime.landesverbaende[lv.id] ) {
                vereinsListe = [...vereinsListe,
                    ...this.getVereineFromLV(lv.id, store.state.realtime.landesverbaende[lv.id]) ]
            }
        });
        return vereinsListe
    }
        getVereineFromLV(lvId, lv){
            return Object.keys(lv.vereine).map(
                id => ({lvId: lvId, nr: lvId+id, ...lv.vereine[id], status: lv.vereine[id].inaktiv===true ? 'inaktiv' : 'aktiv' })
            )
        }

    async exportToExcel(){
        EXCEL_DOWNLOAD.exportJsonToSingleSheet(
            this.getFlatFilteredList(),
            'Vereine',
            TimeStamp.getTodayString(),
            this.getExcelHeaderConfig(),
        );
        return this.filteredList.length
    }
        getFlatFilteredList(){
            return this.filteredList.map((item)=>({
                lvId: item.lvId,
                nr: item.nr,
                name: item.name,
                status: item.status,
                zvrNr: item.zvrNr,
                vereinsSitz_name: item.vereinsSitz?.name,
                vereinsSitz_strasse: item.vereinsSitz?.strasse,
                vereinsSitz_plz: item.vereinsSitz?.plz,
                vereinsSitz_ort: item.vereinsSitz?.ort,
                vereinsSitz_telefon: item.vereinsSitz?.telefon,
                vereinsSitz_email: item.vereinsSitz?.email,
                bankVerbindung_inhaber: item.bankVerbindung?.inhaber,
                bankVerbindung_institut: item.bankVerbindung?.institut,
                bankVerbindung_iban: item.bankVerbindung?.iban,
                post_name: item.postZustellAdresse?.name,
                post_strasse: item.postZustellAdresse?.strasse,
                post_plz: item.postZustellAdresse?.plz,
                post_ort: item.postZustellAdresse?.ort,
            }))
        }
        getExcelHeaderConfig(){
            return [
                {text: 'LV', value: 'lvId'},
                {text: 'nr', value: 'nr'},
                {text: 'Name', value: 'name'},
                {text: 'Status', value: 'status'},
                {text: 'ZVR-Nr', value: 'zvrNr'},
                {text: 'Sitz-Name', value: 'vereinsSitz_name'},
                {text: 'Straße', value: 'vereinsSitz_strasse'},
                {text: 'PLZ', value: 'vereinsSitz_plz'},
                {text: 'Ort', value: 'vereinsSitz_ort'},
                {text: 'Telefon', value: 'vereinsSitz_telefon'},
                {text: 'E-Mail', value: 'vereinsSitz_email'},
                {text: 'Konto-Inhaber', value: 'bankVerbindung_inhaber'},
                {text: 'Institut', value: 'bankVerbindung_institut'},
                {text: 'IBAN', value: 'bankVerbindung_iban'},
                {text: 'Post-Name', value: 'post_name'},
                {text: 'Post-Straße', value: 'post_strasse'},
                {text: 'Post-PLZ', value: 'post_plz'},
                {text: 'Post-Ort', value: 'post_ort'},
            ]
        }
}